<template>
  <v-generic-input
    :label="label"
    :translate-text="translateText"
    :help-text="helpText"
    :id="`${givenId}`"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <v-date-picker
        :id="`${givenId}`"
        v-model="inputVal"
        :placeholder="$t(placeholder)"
        :popover="{ visibility: 'click' }"
        :input-props="{required: required}"
        :is-required="true"
        :min-date="minDate"
        :max-date="maxDate"
        :is-inline="isInline"
        :mode="isRange ? 'range' : ''"
        :is-expanded="isExpanded"
      />

      <div class="text-muted text-center" v-if="isRange && value">
        {{ $t('word.from_date') }} <span class="text-bold">{{ prettyStart }}</span>
        {{ $t('word.until_date').toLowerCase() }} <span class="text-bold">{{ prettyEnd }}</span>.
      </div>
    </template>
  </v-generic-input>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import { GenericInputMixin } from '@/common/utils/mixins';
import moment from 'moment';
import nl from 'moment/locale/nl';
import _GenericInput from './_GenericInput.vue';

moment.updateLocale('nl', nl);

export default {
  name: 'DatePicker',
  components: {
    'v-generic-input': _GenericInput,
    'v-date-picker': DatePicker,
  },
  props: {
    isExpanded: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isInline: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isRange: {
      type: Boolean,
      default() {
        return false;
      },
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    small: {
      default() {
        return false;
      },
    },
    value: {
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  computed: {
    prettyStart() {
      return moment(this.value.start)
        .locale(this.$i18n.locale)
        .format('D MMM YYYY');
    },
    prettyEnd() {
      return moment(this.value.end)
        .locale(this.$i18n.locale)
        .format('D MMM YYYY');
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      givenId: null,
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;
  },
};
</script>

<style>
input.vc-rounded:focus {
  color: #404040;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0 transparent;
  box-shadow: 0 0 0 0 transparent;
}

input.vc-rounded {
  border-width: 0;
  border-bottom-width: 1px;
  border-color: rgba(24,28,33,0.1);
  border-radius: 0;
  color: #4E5155;
  background: rgba(24,28,33,0.015) !important;
  padding-left: 0.5rem;
  font-size: .894rem;
}
</style>
